@defer (when value()) {
  <app-branches-form
    [edit]="false"
    [create]="false"
    [delete]="false"
    [details]="true"
    [value]="value()"
    [access]="access()"
  ></app-branches-form>
}
